import { Route } from "react-router-dom";
import {
  AmenityDetailsPageLoader,
  AmenityDetailsPageAction,
} from "./AmenityDetailsPage/loaders";
import { AmenityDetailsPage } from "./AmenityDetailsPage";
import { AmenityTablePage } from "./AmenityTablePage";
import { AmenityTablePageLoader } from "./AmenityTablePage/loaders";
import { AddReservationPage } from "./AmenityReservationPage";
import {
  AddReservationPageAction,
  AddReservationPageLoader,
} from "./AmenityReservationPage/loaders";
import { ProtectedRoute } from "~/context/ProtectedRoute";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";

export const AmenityPagesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.amenity}
        loader={AmenityTablePageLoader}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <AmenityTablePage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.amenityDetails}
        loader={AmenityDetailsPageLoader}
        action={AmenityDetailsPageAction}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <AmenityDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.amenityReservation}
        loader={AddReservationPageLoader}
        action={AddReservationPageAction}
        element={
          <ProtectedRoute roles={[APITypes.TenantStatusType.Active]}>
            <AddReservationPage />
          </ProtectedRoute>
        }
      />
    </>
  );
};
